import script from "./StickyCTA.vue?vue&type=script&setup=true&lang=ts"
export * from "./StickyCTA.vue?vue&type=script&setup=true&lang=ts"

import "./StickyCTA.vue?vue&type=style&index=0&id=938d525c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-938d525c"]])

export default __exports__